import { render } from "./FAQZhView.vue?vue&type=template&id=1276954f&scoped=true&ts=true"
import script from "./FAQZhView.vue?vue&type=script&lang=ts"
export * from "./FAQZhView.vue?vue&type=script&lang=ts"

import "./FAQZhView.vue?vue&type=style&index=0&id=1276954f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1276954f"]])

export default __exports__